import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const userChangesAdapter = createEntityAdapter({})

const initialState = userChangesAdapter.getInitialState();

export const userChangesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getUserChanges: builder.query({
            query: () => ({
                url: '/userchanges',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedUsers = responseData.map(userchanges => {
                    userchanges.id = userchanges._id
                    return userchanges
                });
                return userChangesAdapter.setAll(initialState, loadedUsers)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'UserChanges', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'UserChanges', id }))
                    ]
                } else return [{ type: 'UserChanges', id: 'LIST' }]
            }
        }),
        addNewUserChanges: builder.mutation({
            query: initialUserData => ({
                url: '/userchanges',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'UserChanges', id: "LIST" }
            ]
        }),       
        updateUserChanges: builder.mutation({
            query: initialUserData => ({
                url: '/userchanges',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserChanges', id: arg.id }
            ]
        }),
        deleteUserChanges: builder.mutation({
            query: ({ id }) => ({
                url: `/userchanges`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserChanges', id: arg.id }
            ]
        }),       
    }),
})

export const {
    useGetUserChangesQuery,
    useAddNewUserChangesMutation,
    useUpdateUserChangesMutation,
    useDeleteUserChangesMutation  
} = userChangesApiSlice

// returns the query result object
export const selectUserChangesResult = userChangesApiSlice.endpoints.getUsers.select();

// creates memoized selector
const selectUserChangesData = createSelector(
    selectUserChangesResult,
    userchangesResult => userchangesResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllUserChanges,
    selectById: selectUserChangesById,
    selectIds: selectUserChangesIds
    // Pass in a selector that returns the users slice of state
} = userChangesAdapter.getSelectors(state => selectUserChangesData(state) ?? initialState)